export default __webpack_public_path__ + "static/media/Amanda_Baroni_Elementos_da_Minha_Natureza_4.932198a1.jpg";